<template>
    <div id="thread-ticket-modal" class="modal fade" tabindex="-1" role="dialog" style="display: none;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title font-normal" id="modalTitle">Link Email Thread To Ticket</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>

                <div class="modal-body">
                    <!-- Add items to existing ticket -->
                    <div class="form">
                        <div class="form-group">
                            <label for="ticket-list">Select Ticket</label>
                            <div id="ticket-list">
                                <select-ticket api="/emails/thread/tickets"
                                               :show-asset-name="true"
                                               v-model="linkForm.ticket">
                                </select-ticket>
                            </div>

                            <span class="invalid-feedback"
                                  :class="{'d-block': linkForm.errors.has('ticket')}"
                                  v-show="linkForm.errors.has('ticket')">
                                    {{ linkForm.errors.get("ticket") }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-success waves-effect waves-light"
                            @click.prevent="link"
                            :disabled="linkForm.busy">
                        {{linkForm.busy ? "Linking..." : "Link Thread"}}
                    </button>

                    <button type="button" class="btn btn-default waves-effect" data-dismiss="modal"
                            :disabled="linkForm.busy">Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
  export default {

    props: ["threadId"],

    data() {
      return {
        linkForm: new AppForm({})
      };
    },

    mounted() {
      let self = this;
      Bus.$on("link-thread-ticket", function() {
        self.showThreadLinkForm();
      });
    },

    methods: {

      showThreadLinkForm() {
        $("#thread-ticket-modal").modal("show");
      },

      hideThreadLinkForm() {
        $("#thread-ticket-modal").modal("hide");
      },

      link() {
        this.linkForm.link = true;
        App.patch("/emails/thread/" + this.threadId + "/ticket/update", this.linkForm)
          .then(() => {
            toastr.success("Email linked to ticket!");
            this.$emit("ticket-linked", this.linkForm.ticket);
            this.hideThreadLinkForm();
          });
      },
    },
  };
</script>
